import { createTheme } from "@mui/material/styles"

const navy = "#000435"
const blue = "#00A3FF"
const green = "#00B67A"
const amber = "#F5A623"
const red = "#E53935"

const sharedButton = {
    styleOverrides: {
        root: {
            boxShadow: "none",
            textTransform: "none",
            fontWeight: 700,
            borderRadius: 999,
            paddingInline: 20,
            "&:hover": {
                boxShadow: "none",
            },
        },
        containedSecondary: {
            backgroundColor: blue,
            "&:hover": {
                backgroundColor: "#0090e0",
            },
        },
    },
}

const adminTheme = createTheme({
    palette: {
        mode: "light",
        primary: { main: navy },
        secondary: { main: blue },
        success: { main: green },
        warning: { main: amber },
        error: { main: red },
        background: {
            default: "#f4f7fb",
            paper: "#ffffff",
        },
        text: {
            primary: navy,
            secondary: "rgba(0, 4, 53, 0.68)",
        },
        divider: "rgba(0, 4, 53, 0.08)",
    },
    typography: {
        fontFamily: '"DM Sans", "Segoe UI", Helvetica, Arial, sans-serif',
        h2: { fontWeight: 800 },
        h4: { fontWeight: 800 },
        h5: { fontWeight: 700 },
        h6: { fontWeight: 700 },
        button: { fontWeight: 700 },
        overline: {
            fontSize: "0.75rem",
            fontWeight: 800,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: blue,
        },
    },
    shape: { borderRadius: 10 },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,400&display=swap');
                body { background-color: #f4f7fb; -webkit-font-smoothing: antialiased; }
            `,
        },
        MuiButton: sharedButton,
        MuiChip: {
            styleOverrides: {
                root: { borderRadius: 999, fontWeight: 600 },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: "none" },
                rounded: { borderRadius: 16 },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: navy,
                    color: "#ffffff",
                    borderRight: "none",
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    marginInline: 8,
                    "&.Mui-selected": {
                        backgroundColor: "rgba(0, 163, 255, 0.15)",
                        color: blue,
                        "& .MuiListItemIcon-root": { color: blue },
                        "&:hover": { backgroundColor: "rgba(0, 163, 255, 0.2)" },
                    },
                    "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.06)" },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: "#f4f7fb",
                    "&.Mui-focused": { backgroundColor: "#ffffff" },
                },
            },
        },
        MuiTextField: { defaultProps: { color: "secondary" } },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    border: "1px solid rgba(0, 4, 53, 0.08)",
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    "& .MuiTableCell-head": {
                        fontWeight: 700,
                        fontSize: "0.75rem",
                        letterSpacing: "0.06em",
                        textTransform: "uppercase",
                        color: "rgba(0, 4, 53, 0.68)",
                        backgroundColor: "#f4f7fb",
                        borderBottom: "1px solid rgba(0, 4, 53, 0.08)",
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    "&:hover": { backgroundColor: "rgba(0, 163, 255, 0.04)" },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: blue,
                    height: 3,
                    borderRadius: 3,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontWeight: 600,
                    "&.Mui-selected": { color: blue, fontWeight: 700 },
                },
            },
        },
        MuiCheckbox: { defaultProps: { color: "secondary" } },
    },
})

export default adminTheme
